import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2008')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('performance') || media.includes('photography') || media.includes('video');
  })
  .slice(0, 4);

export default function JayeRhee() {
  const slides = [
    { src: '/uploads/2016/11/jaye-rheeinstallation.jpg', alt: 'Jaye Rhee work 1' },
    { src: '/uploads/2016/11/jayerhee1.jpg', alt: 'Jaye Rhee work 2' },
    { src: '/uploads/2016/11/jayerhee2.jpg', alt: 'Jaye Rhee work 3' },
    { src: '/uploads/2016/11/jayerhee3.jpg', alt: 'Jaye Rhee work 4' },
    { src: '/uploads/2016/11/jayerhee4.jpg', alt: 'Jaye Rhee work 5' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Jaye Rhee</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Jaye Rhee slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2008</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>We all felt that Jaye Rhee’s videos merit the award because of their subtle sophistication. Although they look simple, the way the artist has made every decision of framing, pace, length and sound ? reveals a restrained outlook that is generous, humble, and refined. The work seems original and timely, not rehashing established precedents but drawing on an exceptionally developed understanding of the past in a format that is accessible and unpretentious.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>Howard Fox was drawn to the enchanting quality of the videos. Peter Frank admired the visual and intellectual surprises they delivered. We all agreed that Rhee is an artist pursuing an original vision that very much deserves recognition by KAFA.</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Howard N. Fox, Curator Emeritus of Contemporary Art, Los Angeles County Museum of Art</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Peter Frank, Editor, THE Magazine, Los Angeles, Senior Curator, Riverside Art Museum</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>David Pagel, Art Critic, Los Angeles Times, Associate Prof. & Chair of Art Dept., Claremont Graduate School, CA, Curator, Blaffer Gallery, University of Houston, TX</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Jaye Rhee revels in the space between the ironic and the poignant with work that simultaneously incorporates video, photography, and performance. Born in Seoul, South Korea, Rhee graduated from the School of the Art Institute of Chicago (BFA, MFA).</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Her work has since been exhibited at various international venues, including Albright­ Knox Art Gallery, Norton Museum of Art, Queens Museum, The Bronx Museum of the Arts, Mori Art Museum (Tokyo), Kobe Biennale 2007, The Seoul Museum of Modern Art, DOOSAN Art Center (Seoul), Gyeonggi Museum of Art (South Korea), Leeum Samsung Museum (Seoul), the Centro para os Assuntos da Arte e Arquitectura (Portugal) and La Triennale di Milano (Milan).</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Rhee also participated in the Artists’ residencies of Skowhegan School of Painting and Sculpture in Main 2009, Palais de Tokyo Workshop Program in Paris 2009, Changdong International Studio Program in Seoul 2008, Aljira Emerge Program at Aljira Center for Contemporary Art in New Jersey 2008, Artist in Market Place Program in Bronx Museum in 2005 and Lower Manhattan Cultural Council’s Swing Space Program 2012.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Among her awards are the Yonkang (DOOSAN) Art Award 2011, Franklin Furnace Fund 2010, SeMA Young Artist Grant from Seoul Museum of Art 2010, Arts Council Korea Grant for Cultural Exchange 2010 and 2009, and Korea­America Foundation for the Arts Award 2008.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>In 2010, Spector Press released her monograph Imageless. This retrospective of her oeuvre charts the evolution of her work over a decade and is accompanied by essays that deal with Rhee’s approach to her art by Carol Becker, Raul Zamudio, Sara Reisman and Edwin Ramoran. Prior to its publication, her work had already been featured in Carol Becker’s essay “Intimate, Immediate, Spontaneous, Obvious: Educating the Unknowing Mind” in Buddha Mind in Contemporary Art (University of California Press). It has also been the subject of reviews in numerous periodicals, including ARTnews, The New York Times, Palm Beach daily, Artslant, Artlyst, Art in Culture and Art Asia Pacific Magazine.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>She lives and works in New York.</p>

            <a href='https://jrhee.com/' className='nav-link'>Artist's Website</a>
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
